// NYSE / NASDAQ regular session, 09:30–16:00 America/New_York, Mon–Fri. Exchange holidays are not modelled (v1).

const NY = 'America/New_York';

function nyParts(now: number) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: NY, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(new Date(now));
  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? '';
  return { weekday: get('weekday'), hour: Number(get('hour')) % 24, minute: Number(get('minute')), date: `${get('year')}-${get('month')}-${get('day')}` };
}

export function isUsMarketOpen(now: number = Date.now()): boolean {
  const { weekday, hour, minute } = nyParts(now);
  if (weekday === 'Sat' || weekday === 'Sun') return false;
  const m = hour * 60 + minute;
  return m >= 9 * 60 + 30 && m < 16 * 60;
}

/** 'pre' before the open, 'open' during the session, 'post' after the close (weekends count as post). */
export function usSessionPhase(now: number = Date.now()): 'pre' | 'open' | 'post' {
  const { weekday, hour, minute } = nyParts(now);
  if (weekday === 'Sat' || weekday === 'Sun') return 'post';
  const m = hour * 60 + minute;
  if (m < 9 * 60 + 30) return 'pre';
  if (m < 16 * 60) return 'open';
  return 'post';
}

export function todayNY(now: number = Date.now()): string {
  return nyParts(now).date;
}

export function formatNYClock(ts: number): string {
  return new Intl.DateTimeFormat('en-US', { timeZone: NY, hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(ts)) + ' ET';
}
